import type { ActiveTheme, ResolvedColorMode } from "./types"

export function resolveSystemColorMode(): ResolvedColorMode {
  if (typeof window === "undefined") return "dark"
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

export function applyThemeToDocument(theme: ActiveTheme, colorMode: ResolvedColorMode) {
  if (typeof document === "undefined") return
  const root = document.documentElement
  root.classList.remove("light", "dark")
  root.classList.add(colorMode)
  root.dataset.theme = String(theme.id)
  root.dataset.colorMode = colorMode

  const variables = {
    ...theme.tokens.shared,
    ...(colorMode === "dark" ? theme.tokens.dark : theme.tokens.light),
  }

  for (const [name, value] of Object.entries(variables)) {
    root.style.setProperty(name, value)
  }

  if (variables["--theme-radius"]) {
    root.style.setProperty("--radius", variables["--theme-radius"])
  }
  if (variables["--theme-font-sans"]) {
    root.style.setProperty("--font-sans", variables["--theme-font-sans"])
  }
  if (variables["--theme-font-mono"]) {
    root.style.setProperty("--font-mono", variables["--theme-font-mono"])
    root.style.setProperty("--font-data", variables["--theme-font-mono"])
  }
  if (variables["--theme-font-heading"]) {
    root.style.setProperty("--font-forensic", variables["--theme-font-heading"])
  }

  if (typeof document !== "undefined") {
    document.title = theme.brand.appName
    const faviconHref = theme.brand.faviconUrl
    if (faviconHref) {
      let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null
      if (!link) {
        link = document.createElement("link")
        link.rel = "icon"
        document.head.appendChild(link)
      }
      link.href = faviconHref
    }
  }
}
